// Premium unlock state, persisted in localStorage so it survives
// IndexedDB resets ("Start New Inspection").
const UNLOCK_KEY = 'car-pdi-unlock';
const UNLOCK_EVENT = 'car-pdi-unlock-changed';

// Single source of truth for the unlock price: VITE_UNLOCK_AMOUNT_PAISE
// (in paise) drives BOTH the displayed price here (build-time) and the
// Razorpay charge in api/create-order.js (runtime), so changing that one
// env var keeps the UI and the actual charge in sync. Defaults to ₹99.
const UNLOCK_AMOUNT_PAISE = Number(import.meta.env.VITE_UNLOCK_AMOUNT_PAISE) || 9900;
const rupees = UNLOCK_AMOUNT_PAISE / 100;
export const UNLOCK_PRICE_RUPEES = Number.isInteger(rupees) ? rupees : rupees.toFixed(2);

// Kill switch for the ₹99 paywall while no live Razorpay key is set.
// Defaults to disabled (flag unset) so a fresh deploy never shows a
// payment flow it can't actually complete. Set VITE_PAYMENTS_ENABLED=true
// once RAZORPAY_KEY_ID/SECRET hold live keys.
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === 'true';

export const getUnlock = () => {
  try {
    return JSON.parse(localStorage.getItem(UNLOCK_KEY));
  } catch {
    return null;
  }
};

// While payments are disabled, every gated feature (PDF report, printable
// checklist, dealer scripts) behaves as already-unlocked - every call site
// checks this before showing a price badge or the paywall, so this one
// flag hides the payment option everywhere without touching those pages.
export const isUnlocked = () => !PAYMENTS_ENABLED || Boolean(getUnlock()?.paymentId);

export const saveUnlock = ({ paymentId, orderId }) => {
  localStorage.setItem(
    UNLOCK_KEY,
    JSON.stringify({ paymentId, orderId, unlockedAt: Date.now() })
  );
  window.dispatchEvent(new Event(UNLOCK_EVENT));
};

export const onUnlockChange = (listener) => {
  window.addEventListener(UNLOCK_EVENT, listener);
  return () => window.removeEventListener(UNLOCK_EVENT, listener);
};
